import { render } from "./RelespelhoPonto.vue?vue&type=template&id=9d5febd0&scoped=true"
import script from "./RelespelhoPonto.vue?vue&type=script&lang=js"
export * from "./RelespelhoPonto.vue?vue&type=script&lang=js"

import "./RelespelhoPonto.vue?vue&type=style&index=0&id=9d5febd0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5febd0"]])

export default __exports__